'use strict';

export const bContact = {
	container: document.querySelectorAll('.bContact'),
	buttonDisplay: document.querySelectorAll('.bContact_link'),
	bContact_form: document.querySelector('.bContact_form'),

	init() {
		this.buttonDisplay.forEach((buttons) => {
			buttons.onclick = function() {
				this.classList.toggle('opened');
				this.querySelectorAll('.bContact_toggleForm ').forEach((el) => {
					el.classList.toggle('hidden');
				});

				//etat du formulaire qui suit le bloc
				//console.log(form)
				let form = this.closest('.bContact').nextElementSibling;
				if (form) {
					form.classList.toggle('open');

					if (form.style.maxHeight) {
						form.style.maxHeight = null;
					} else {
						form.style.maxHeight = parseInt(form.scrollHeight + 220) + 'px';
					}
				}
				else{
					//console.log('bContact_form : inexistant')
				}
			};
		});
	}
};



// WEBPACK FOOTER //
// ./src/scripts/components/bContact.js